"use client";
import React from "react";
import { ActiveThemeProvider } from "../active-theme";
import { TimeRangeProvider } from "@/contexts/TimeRangeContext";
import { AggregationProvider } from "@/contexts/AggregationContext";

export default function Providers({
  activeThemeValue,
  children
}: Readonly<{
  activeThemeValue: string;
  children: React.ReactNode;
}>) {
  return (
    <ActiveThemeProvider initialTheme={activeThemeValue}>
      <TimeRangeProvider>
        <AggregationProvider>{children}</AggregationProvider>
      </TimeRangeProvider>
    </ActiveThemeProvider>
  );
}
